// スマホのヘッダーのアイコンボタン（上部バーのハンバーガー・組織切り替え・ツアーと、
// チャットの「一覧へ戻る」）。押せる範囲を 48px にそろえる。
// 上部バーの高さ（index.css の --mobile-topbar-h）はこのボタンとロゴより大きくしておく
export const mobileHeaderIconButtonClass = 'h-12 w-12'

// スマホのヘッダーのアイコンの寸法（上部バーのロゴ 56px と釣り合う大きさ）。
// phosphor-fill は className の寸法が効かないため、Icon の width / height に数値で渡す
export const MOBILE_HEADER_ICON_SIZE = 36
